__turbopack_context__.v({
  "className": "BKMwJW_className",
  "variable": "BKMwJW_variable",
});
